import { Avatar, Icon } from '@chakra-ui/react'
import { memo } from 'react'
import { ImageX } from '../../../utils/constants/icons'

const LazyLoadAvatarInner = ({
  src,
  w,
  h,
  isImage,
  onClick,
  name,
}: {
  src: string | undefined | null
  w?: number
  h?: number
  isImage?: boolean
  name?: string
  onClick?: () => void
}) => {
  if (src === '' || !src)
    return (
      <Avatar
        w={w ? `${w}px` : '20px'}
        h={h ? `${h}px` : '20px'}
        cursor={onClick ? 'pointer' : 'default'}
        onClick={onClick ? onClick : () => {}}
        name={name}
        size="sm"
        overflow="hidden"
        bg="neutral.50"
        color="neutral.500"
        icon={
          isImage ? (
            <Icon
              w={w ? `${Math.min(w - 8, 40)}px` : '12px'}
              h={h ? `${Math.min(h / 2, 40)}px` : '12px'}
              color="neutral.500"
              fill="none"
            >
              <ImageX />
            </Icon>
          ) : undefined
        }
      />
    )

  return (
    <img
      loading="lazy"
      decoding="async"
      onClick={onClick}
      src={src}
      alt={name ?? ''}
      style={{
        borderRadius: '50%',
        objectFit: 'cover',
        cursor: onClick ? 'pointer' : 'default',
        width: w ? `${w}px` : '20px',
        height: h ? `${h}px` : '20px',
        minHeight: h ? `${h}px` : '20px',
        maxHeight: h ? `${h}px` : '20px',
        minWidth: w ? `${w}px` : '20px',
        maxWidth: w ? `${w}px` : '20px',
        display: 'block',
      }}
    />
  )
}

const LazyLoadAvatar = memo(LazyLoadAvatarInner, (prev, next) => {
  return (
    prev.src === next.src &&
    prev.w === next.w &&
    prev.h === next.h &&
    prev.isImage === next.isImage &&
    prev.name === next.name
  )
})

export default LazyLoadAvatar
